// extracted by mini-css-extract-plugin
export var table = "_x8-0";